import { LegacyCross } from '@components/icons'
import HelpSupport from '@components/profile/HelpSupport'
import { SliceZone } from '@prismicio/react'
import { clearAllBodyScrollLocks, disableBodyScroll } from 'body-scroll-lock'
import cn from 'clsx'
import { useEffect, useRef } from 'react'
import { components } from '../../../slices'
import s from './ProductSidebar.module.css'

interface ProductSidebarProps {
  sidebarData: any
  onClose: () => void
}

const ProductSidebar: React.FC<ProductSidebarProps> = ({
  onClose,
  sidebarData,
}) => {
  const sidebarRef = useRef() as React.MutableRefObject<HTMLDivElement>
  const contentRef = useRef() as React.MutableRefObject<HTMLDivElement>

  const onKeyDownSidebar = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.code === 'Escape') {
      onClose()
    }
  }

  useEffect(() => {
    if (sidebarRef.current) {
      sidebarRef.current.focus()
    }

    const contentElement = contentRef.current

    if (sidebarData !== null) {
      disableBodyScroll(contentElement, { reserveScrollBarGap: true })
    } else {
      sidebarRef.current.blur()
    }

    return () => {
      clearAllBodyScrollLocks()
    }
  }, [sidebarData])

  const slices = sidebarData?.slices
  const helpBlockBlock = sidebarData?.helpblogblock
  const type = sidebarData?.type

  return (
    <div
      ref={sidebarRef}
      onKeyDown={onKeyDownSidebar}
      tabIndex={1}
      className={cn(
        'absolute inset-0 overflow-hidden w-full h-full ',
        sidebarData !== null ? 'z-50' : '-z-10'
      )}
    >
      {sidebarData !== null && <div className={s.backdrop} onClick={onClose} />}
      <div
        className={cn(s.root, { [s.sidebarOpen]: sidebarData !== null })}
        ref={contentRef}
      >
        <div className={cn(s.contentRoot)}>
          <div className={s.contentContainer}>
            <div className={'sticky top-0 z-10 block'}>
              <header className={s.header}>
                <div className="text-brand-dark-grey text-body3 font-bold sm:text-label sm:text-left text-center flex-1">
                  {type == 'sizechart' ? 'SIZE GUIDE' : 'WATER RESISTANCE'}
                </div>
                {onClose && (
                  <button
                    onClick={onClose}
                    aria-label="Close"
                    className="hover:text-accent-5 transition ease-in-out duration-150 focus:outline-none ml-auto"
                  >
                    <LegacyCross className="h-5 w-5 text-brand-dark-grey hover:text-accent-3" />
                  </button>
                )}
              </header>
            </div>
            <div className="px-5 md:px-6 pt-8 text-body1">
              <SliceZone slices={slices} components={components} />
            </div>
            <HelpSupport
              heading="STILL NEED HELP?"
              blog_data={helpBlockBlock}
              showFindStoreItem
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProductSidebar
